import { render, staticRenderFns } from "./SecurityBlock.vue?vue&type=template&id=1d3ecd11&scoped=true&"
import script from "./SecurityBlock.vue?vue&type=script&lang=js&"
export * from "./SecurityBlock.vue?vue&type=script&lang=js&"
import style0 from "./SecurityBlock.vue?vue&type=style&index=0&id=1d3ecd11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ecd11",
  null
  
)

export default component.exports